
import React, { createContext, useEffect, useState, ReactNode, useContext } from 'react';
import { User } from '../model/User';
import { IAuthService } from '../services/IAuthService';

const AuthContext = createContext<User | undefined>(undefined);

const useAuth = () => {
  return useContext(AuthContext);
}

const AuthProvider = ({ authService, children }: Props) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = authService.onAuthStateChanged(user => {
      console.log('Auth state changed:', user);
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={currentUser}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

interface Props {
  authService: IAuthService,
  children: ReactNode
}

export { AuthProvider, useAuth };

